import axios from 'axios';

export const saveSpecialPayment = (data) => {
    return axios.post('/api/admin/special-payments', data);
};

export const getSpecialPayments = () => {
    return axios.get('/api/admin/special-payments');
};

export const archiveSpecialPayment = (specialPaymentID, data) => {
    return axios.patch(`/api/admin/special-payments/${specialPaymentID}/archive`, data);
};
